var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"no-gutters":"","align":"center","justify":"center"}},[_c('p',{class:`text-${_vm.align}`},[_vm._v(_vm._s(_vm.item ? _vm.item : ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }